{
  "draftNotice": "草案，待法律顾问审阅——尚非经批准的法律文本。",
  "popup": {
    "title": "使用 Bennie 之前",
    "bodyInternal": "贵组织已接受 Bennie 服务条款（版本 {{version}}）。继续使用即表示您确认：您是授权用户；您仅会将 Bennie 用于贵组织的内部目的；您会对 Bennie 的内容及非公开信息保密；您不会复制、逆向工程或分享 Bennie。",
    "bodyConsultant": "贵组织已接受 Bennie 服务条款（版本 {{version}}）。继续使用即表示您确认：您是授权用户；您仅会代表聘用您的组织使用 Bennie；您会对 Bennie 的内容及非公开信息保密；您不会复制、逆向工程或分享 Bennie。",
    "keyLimits": "主要限制：Bennie 按“现状”提供，输出可能存在错误，必须由合格人员审核，且责任设有上限。",
    "viewFull": "查看完整条款",
    "agree": "我已阅读并同意。",
    "continue": "继续",
    "mustAgree": "您必须同意条款才能使用 Bennie。",
    "close": "关闭",
    "signOut": "退出登录",
    "retry": "重试",
    "checking": "正在检查您的访问权限",
    "blockedHint": "您需要同意条款才能使用 Bennie。您也可以选择退出登录。",
    "statusFailed": "无法检查条款状态，请重试。",
    "acceptFailed": "无法记录您的同意，请重试。"
  },
  "full": {
    "title": "Bennie 服务条款及最终用户协议",
    "versionLine": "版本 {{version}}",
    "intro": "本条款是 [LEGAL_ENTITY_NAME]（“Kyronyx”、“我们”）与安装 Bennie 的组织（“客户”）之间的协议，同时约束代表客户使用 Bennie 的每一位个人（“用户”）。",
    "sections": {
      "s1": {
        "title": "许可与允许的使用",
        "c1": "Kyronyx 授予客户一项有限的、非排他的、不可转让的、不可再许可的、可撤销的许可，允许客户在本条款期限内安装和使用 Bennie，且仅限客户的内部业务目的。",
        "c2": "仅客户授权的个人（“授权用户”）可以使用 Bennie。授权用户可以是客户的员工，或客户聘用的顾问。顾问只能代表客户使用 Bennie，不得为其自身或任何其他方的目的使用。",
        "c3": "客户的授权签署人在安装时、在任何 Bennie 组件部署或启用之前接受本条款。每位用户在以其个人档案首次启动时，还须确认本条款中的使用、保密和责任规则。Kyronyx 记录每次接受：由谁接受、何时接受、接受的条款版本。未经接受，Bennie 不会启用，用户也无法继续。",
        "c4": "客户须对其授权用户遵守本条款负责。"
      },
      "s2": {
        "title": "副本与安装",
        "c1": "客户仅可在 Kyronyx 为其提供或批准的环境中安装和运行 Bennie。",
        "c2": "客户仅可在这些环境中为运行所必需的技术范围内以及为日常备份而制作 Bennie 副本。所有副本均受本条款约束，并须保留全部专有权声明。",
        "c3": "客户不得制作或分发任何其他副本，无论全部或部分。"
      },
      "s3": {
        "title": "限制",
        "c1": "除本条款允许外，客户和用户不得复制、修改、翻译 Bennie 或创作其衍生作品。",
        "c2": "客户和用户不得对 Bennie 进行逆向工程、反编译或反汇编，也不得以其他方式试图获取其源代码、模型、提示词、精选知识或内部运作方式，但法律不允许此限制的范围除外。",
        "c3": "客户和用户不得向非授权用户分享、出售、出租、再许可 Bennie 或其非公开内容，或向其提供访问权限，也不得利用 Bennie 开发竞争性产品或服务。",
        "c4": "客户和用户不得规避访问控制、使用限制或安全措施，也不得违反适用法律使用 Bennie。"
      },
      "s4": {
        "title": "保密",
        "c1": "“保密信息”指 Bennie 的软件、提示词、精选知识、方法论、文档、定价，以及 Kyronyx 提供的任何其他非公开信息，以及本条款的条款内容。",
        "c2": "客户和用户必须对保密信息保密，仅在本条款允许的范围内使用，以不低于合理的谨慎程度加以保护，并仅向有需要的授权用户披露。",
        "c3": "上述义务不适用于以下信息：并非因客户或用户的过错而公开或成为公开的信息；此前已被其合法知悉的信息；或从第三方合法获得且无限制的信息。法律要求的披露是允许的，但在法律允许的情况下，客户应及时通知 Kyronyx。",
        "c4": "上述义务在本条款终止后继续有效。"
      },
      "s5": {
        "title": "所有权",
        "c1": "Kyronyx 及其许可方拥有 Bennie 及其中的全部知识产权。本条款授予客户使用 Bennie 的许可，不转让所有权。",
        "c2": "客户拥有其输入 Bennie 的内容（“客户内容”）。客户授予 Kyronyx 为提供 Bennie 所需而处理客户内容的有限权利。[DATA_PROCESSING_TERMS_REFERENCE]"
      },
      "s6": {
        "title": "反馈",
        "c1": "如客户或用户向 Kyronyx 提出有关 Bennie 的建议，Kyronyx 可不受限制且无需付费地使用这些建议。"
      },
      "s7": {
        "title": "第三方服务与人工智能输出",
        "c1": "Bennie 依赖第三方服务，包括人工智能模型。这些服务可能有其自身条款，Kyronyx 对其无法控制的服务不承担责任。",
        "c2": "Bennie 的输出由人工智能生成。输出可能不完整、不准确或已过时，相似的输入也可能产生不同的输出。"
      },
      "s8": {
        "title": "免责声明——Bennie 按“现状”提供",
        "c1": "在法律允许的最大范围内，Bennie 及其输出均按“现状”和“可用状态”提供。Kyronyx 不作任何明示或默示的保证，包括适销性、特定用途适用性、准确性和不侵权的保证。",
        "c2": "Kyronyx 不保证 Bennie 不会中断或无错误。"
      },
      "s9": {
        "title": "输出审核",
        "c1": "输出可能存在错误。依赖任何输出之前，必须由合格人员审核。客户对其使用输出的方式以及基于输出作出的任何决定自行负责。",
        "c2": "Bennie 的输出不构成法律、财务、税务、审计或其他专业意见。"
      },
      "s10": {
        "title": "责任限制",
        "c1": "在法律允许的最大范围内，对于因 Bennie 或本条款引起或与之相关的任何间接、附带、特殊、后果性或惩罚性损害，或利润、收入、数据或商誉的损失，Kyronyx 不承担责任。",
        "c2": "Kyronyx 因 Bennie 或本条款引起或与之相关的全部累计责任不超过 [LIABILITY_CAP]。",
        "c3": "本条款中的任何内容均不限制法律规定不得限制的责任。[LIABILITY_CARVE_OUTS]"
      },
      "s11": {
        "title": "期限与终止",
        "c1": "本条款自客户的授权签署人接受时开始，持续至终止。",
        "c2": "任何一方可提前 [TERMINATION_NOTICE_PERIOD] 书面通知终止。如客户或用户严重违反本条款，Kyronyx 可立即暂停或终止。",
        "c3": "终止后，客户的许可结束，客户和用户须停止使用 Bennie，客户须按 Kyronyx 的指示删除或归还保密信息。第 3、4、5、8、9、10、12 和 13 条在终止后继续有效。"
      },
      "s12": {
        "title": "适用法律与争议",
        "c1": "本条款受 [GOVERNING_JURISDICTION] 法律管辖，不考虑其法律冲突规则。",
        "c2": "[GOVERNING_COURT_VENUE] 的法院对因本条款引起或与之相关的争议拥有专属管辖权。[DISPUTE_RESOLUTION_PROCESS]"
      },
      "s13": {
        "title": "一般条款",
        "c1": "Kyronyx 可更新本条款。每次更新均以新版本发布。在 Kyronyx 要求时，客户的授权签署人和用户须先接受新版本，方可继续使用 Bennie。",
        "c2": "如任何条款无法执行，其余条款仍然有效。未经 Kyronyx 书面同意，客户不得转让本条款。本条款连同双方之间的任何订单或部署协议，构成有关 Bennie 的完整协议。[ORDER_OF_PRECEDENCE]",
        "c3": "有关本条款的问题：[NOTICE_CONTACT]。"
      }
    }
  }
}
